import { lazy } from 'react'

export const SubscriptionPage = lazy(() => import('./SubscriptionPage'))
